/* eslint-disable no-template-curly-in-string */
import React, { useState, useEffect, useRef } from 'react'
import LoadingWithText from './components/LoadingWithText/LoadingWithText'

import IpsaContext from './context/IpsaContext'
import SidebarContext from './context/SidebarContext'
import { GetUserInformation } from './store/UserClient'

const UserStateWrapper = ({ children }) => {
    let userStateObj = {
        status: {},
        userInfo: {},
        subscription: {},
        cardInformation: {},
        insights: {},
        refreshUser: () => {
            GetUserInformationFromApi(this)
        },
    }
    const [userLoadingError, setUserLoadingError] = useState(false)
    const [isLoadingUserState, setIsLoadingUserState] = useState(true)
    const [userState, setUserState] = useState(userStateObj)
    const stateRef = useRef()
    stateRef.current = userState

    const SetSidebar = (value) => {
        setSidebarState((prevState) => ({
            ...prevState,
            sidebarOpen: value,
        }))
    }

    const SetFullScreen = (value) => {
        setSidebarState((prevState) => ({
            ...prevState,
            fullScreen: value,
        }))
    }

    const [sidebarState, setSidebarState] = useState({
        sidebarOpen: true,
        setSidebar: SetSidebar,
        fullScreen: false,
        setFullScreen: SetFullScreen,
    })

    const GetUserInformationFromApi = async () => {
        // setIsLoadingUserState(true)
        GetUserInformation()
            .then((user) => {
                const {
                    data: { userInfo, subscription, cardInformation, insights },
                } = user

                // payload = userStateDefault
                const updatedState = {
                    status: {},
                    userInfo,
                    subscription,
                    cardInformation,
                    insights,
                    refreshUser: GetUserInformationFromApi,
                }

                if (JSON.stringify(stateRef.current) === JSON.stringify(updatedState)) {
                    //if no updates do not re-render /reset state
                    return
                } else {
                    setUserState(updatedState)
                }
            })
            .catch((e) => {
                console.error(e)
                setUserLoadingError(true)
            })
            .finally(() => {
                setIsLoadingUserState(false)
            })
    }

    useEffect(() => {
        GetUserInformationFromApi()
    }, [])

    if (isLoadingUserState) {
        return <LoadingWithText text="Loading User Information" />
    }

    if (userLoadingError) {
        return <LoadingWithText text="Error loading user information" />
    }

    if (
        userState == null ||
        userState.subscription == null ||
        userState.subscription.status == null
    ) {
        return (
            <LoadingWithText text="No current subscription information for the logged in user. Contact support." />
        )
    }

    return (
        <IpsaContext.Provider value={userState}>
            <SidebarContext.Provider value={sidebarState}>{children}</SidebarContext.Provider>
        </IpsaContext.Provider>
    )
}

export default UserStateWrapper
